// @flow
import React, { Component } from 'react';
import type { BannerSequence } from 'store/modules/banners';
import { connect } from 'react-redux';
import type { State } from 'store';

import BannerSequences from 'components/banner/BannerSequences/BannerSequences';

type Props = {
  sequences: ?(BannerSequence[]),
  username: string,
  currentBannerId: string,
};

class BannerSequencesContainer extends Component<Props> {
  render() {
    const { sequences, username, currentBannerId } = this.props;

    return (
      <BannerSequences
        sequences={sequences}
        username={username}
        currentBannerId={currentBannerId}
      />
    );
  }
}

export default connect(
  ({ banners }: State) => ({
    sequences: banners.sequences,
    currentBannerId: banners.banner && banners.banner.id,
  }),
  () => ({}),
)(BannerSequencesContainer);



// WEBPACK FOOTER //
// ./src/containers/banner/BannerSequencesContainer.js